import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TestLS from './TestLS';
import TestM from './TestM';
import TestI from './TestI';
import { useHistory } from 'react-router-dom';

function Test() {
	const selectedTest = useSelector(state => state.testSelected);
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		if (!selectedTest || !selectedTest.title) {
			const stored = localStorage.getItem('selectedTest');
			if (stored) {
				const parsed = JSON.parse(stored);
				dispatch({ type: 'SET_SELECTED_TEST', payload: parsed.title });
			} else {
				history.replace('/usertests');
			}
		}
	}, [selectedTest, dispatch, history]);

	if (!selectedTest || !selectedTest.title) {
		return <div className="test__container">No test selected.</div>;
	}

	if (selectedTest.title === 'Learning Strategy Test') {
		return <TestLS />;
	} else if (selectedTest.title === 'Media Test') {
		return <TestM />;
	} else if (selectedTest.title === 'Interactivity Test') {
		return <TestI />;
	} else {
		return <div className="test__container">Unknown test type.</div>;
	}
}

export default Test;
